import * as e from "react";
import i from "../lib/IconBase.es.js";
import r from "../defs/MapPinLine.es.js";
const o = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(i, { ref: a, ...n, weights: r }));
o.displayName = "MapPinLineIcon";
const p = o;
export {
  p as MapPinLine,
  o as MapPinLineIcon
};
